import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {MainLayoutComponent} from '../layout/main-layout/main-layout.component';
import {ApprovalsComponent} from './approvals.component';

const routes: Routes = [
  {
    path: 'approvals',
    component: MainLayoutComponent,
    children: [
      { path: '', component: ApprovalsComponent }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ApprovalsRoutingModule { }